module.exports = __webpack_public_path__ + "static/img/videobanner.22ae1f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videobanner.png
// module id = G3Dk
// module chunks = 1